import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { removeUserToken } from '../../_helpers/auth/secureToken';
import { logoutHandler } from '../../_services/LOGOUT/logout.service';
import { clearUserDetail } from '../../redux/user/userDataActions';
import { useDispatch } from 'react-redux';

export const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        // 1. Clear user data from redux
        dispatch(clearUserDetail());

        // 2. Call logout API if needed
        await logoutHandler({});

        // 3. Remove token
        removeUserToken();

        // 4. Navigate to login
        navigate('/login');
      } catch (error) {
        console.error("Logout failed:", error);
        // Still navigate to login even on error (optional)
        navigate('/login');
      }
    })();
  }, [dispatch, navigate]);

  return null;
};
